import React, { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import _ from "lodash"; // Using lodash for debounce

import dooctilogo from "../assets/images/Dooctilogo.svg";
import skyfalllogo from "../assets/images/SKyfalllogo.png"
import gtawklogo from "../assets/images/gtawk.png"
import { useDispatch, useSelector } from "react-redux";
import pausewave from "../assets/images/pause.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WaitingCalls from "./callWaiting";
import io from 'socket.io-client'
import {
  Hangup,
  Resume,
  Pause,
  Logout,
  CreateTicket,
  FetchTicket,
  MakeManualcall,
  FetchDispo,
  CustomerInfo,
  AgentFetch,
  Createcrm,
} from "../redux/apicalling/dispatchfunction";
import JsSIP from "jssip";
import Autodial from "./autodialpage";
import { useNavigate } from "react-router-dom";
import ringtoneSrc from "../assets/audio/ringtone.wav";
import Dialpad from "./dialpad";
import {
  faPhone,
  faArrowLeft,
  faHouse,
  faUser,
  faDashboard,
  faKiss,
  faKeyboard,
} from "@fortawesome/free-solid-svg-icons";
import Comtemplete from "./comtemplete";
import CallLog from "./calllogpage";

import Webphone from "../components/webphone";
import BottomNavigator from "../components/bottomnavigation";
import Incomingcallscreen from "../components/incomingcallpage";
import { setSession } from "../redux/RTCsession/sessionAction";
import { setCallerInsights } from "../redux/callerinsights/insightaction";
import { setcallstatus } from "../redux/callstatus/callstatusaction";
import {
  rtcprocess,
  rtcfailed,
  rtcended,
  setshowcalllogpage,
  setagentstatus,
  setagentreadystatus,
} from "../redux/backgroundpermission/permission-action";
import Disposcreen from "./dispopage";
import { setcutomerinfo } from "../redux/leadinfo/customerinfoaction";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { AutoDialCurrent, Autolead } from "../redux/autodial/autodialaction";
import Dashboard from "./dashboardpage";
import "../assets/css/bottomnavigation.css";
import { red } from "@mui/material/colors";
import { networkstatus, oncall, oncall_number, socketconnection, socketmessage, websocketstatus } from "../redux/background/backgroundAction";
import { forceLoutAction, maskPhoneNumber } from "../utils/common";
import PopupScreen from "./popupScreen";
// import customerinfoReducer from '../redux/leadinfo/customerinforeducer';


function formatCallDuration(durationInSeconds) {
  const minutes = Math.floor(durationInSeconds / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (durationInSeconds % 60).toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
}
function Homepage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const timerRef = useRef(null);
  const user_name1 = localStorage.getItem("username");
  const [tenantid, setTenantId] = useState("");
  const [useremail, setUserEmail] = useState("");
  const [entity_type, setEntityType] = useState("");
  const [userid, setUserId] = useState("");
  const [entity_id, setEntityId] = useState("");
  const [isListenerAdded, setIsListenerAdded] = useState(false); // Track if listener is already added

  const [response, setResponse] = useState("");
  const [phone, setPhone] = useState("");
  const [callStatus, setCallStatus] = useState("On Call1"); // Initialize as 'idle'
  const [pause, setPause] = useState(false);
  const [awayOptionsOpen, setAwayOptionsOpen] = useState(false); // New state variable
  const [badge, setBadge] = useState("Away"); // Initialize with the default status
  const [isDispositionSelected, setIsDispositionSelected] = useState(false);
  const [webphone, setWebphone] = useState(false);

  const [callername, setcallername] = useState("");
  const [callernumber, setCallernumber] = useState("");

  const [leadname, setLeadName] = useState("Unknown Name"); //incomingcall
  const [station, setStation] = useState("");
  const [incomingscreen, setIncomingscreen] = useState(false);
  const [inboundcall, setInboundcall] = useState(false); // show + and eye icon in IB call
  const [showdashboard, setShowDashboard] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [userStatus, setUserStatus] = useState("User is offline")
  const [sipOptions, setsipOptions] = useState({
    mediaConstraints: {
      audio: true,
      video: false,
    },
  });
  const [callDuration, setCallDuration] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [isOnHold, setIsOnHold] = useState(false);
  const [callStartTime, setCallStartTime] = useState(null);
  const [incomingdetails, setIncomingdetails] = useState(false);
  const [dispositionStatusOptions, setDispositionStatusOptions] = useState("");
  const [callNotes, setCallNotes] = useState("");
  const [dispositionStatus, setDispositionStatus] = useState("");
  const [incomingdata, setIncomingdata] = useState("");
  const [inboundnumber, setInboundnumber] = useState("");
  //Inbound lead detail
  const [ibleadowner, setIbLeadOwner] = useState("");
  const [ibleaddate, setIbLeadDate] = useState("");
  const [ibleadid, setIbLeadId] = useState("");
  const [starttimer, setStarttimer] = useState(false);
  const [callended, setCallended] = useState(true);
  const [crmownername, setcrmownername] = useState("");

  const ringtoneRef = useRef(new Audio(ringtoneSrc));
  let station2 = localStorage.getItem("station");
  const backgroundstate = useSelector((state) => state.bgpermission);
  const [showDialpad, setShowDialpad] = useState(false);

  const [iconType, setIconType] = useState(faPhone); // Manage the icon type
  const [showCallLog, setShowCallLog] = useState(
    backgroundstate.setshowcalllogpage
  ); // Initial state from backgroundstate
  const agentavailable_state = JSON.parse(localStorage.getItem("agentstatus"));
  const [Autodialflag, SetAutodialflag] = useState(false);
  const [is_incoming, setis_incoming] = useState(false);
  const [barmenuvalue, setbarmenuvalue] = useState("1");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const selectedCampaign = localStorage.getItem("selectedCampaign");
  const agent = localStorage.getItem('user')
  const extension = localStorage.getItem('extension')
  const [liveagentdata, setLiveagentdata] = useState("");
  const [favicon, setFavicon] = useState()
  let local_showautodialpage = JSON.parse(
    localStorage.getItem("Showautodialpageui")
  );
  const callDataRef = useRef('');
  let livecall_status = JSON.parse(localStorage.getItem("livecall"));
  const config_api = JSON.parse(localStorage.getItem("config"));
  const customer_info_state = useSelector((state) => state.crmcustomerinfo);
  const session_state = useSelector((state) => state);
  const [isTabActive, setIsTabActive] = useState(true);
  const[popup,SetPopup]=useState(false)
  const [waitingCalls, setWaitingCalls] = useState(
    [
      // {id: '1737539847.9880559', pn: '9567236606', qu: 'haripandi_8071893319', du: '00:00:03'},
      // {id: '1737539847.9880510', pn: '9567236607', qu: 'haripandi_8071893319', du: '00:00:06'}
    ]);
  let sip_status = JSON.parse(localStorage.getItem("sipstatus"));
  const local_customer_info = JSON.parse(localStorage.getItem("customer_info"));
  const agent_name = localStorage.getItem("username");
  useEffect(() => {
    socketIo();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true); // Tab is active
        localStorage.setItem("isTabActive", true);
      } else {
        setIsTabActive(false); // Tab is inactive
        localStorage.setItem("isTabActive", false);
      }
      //   const isActive = !document.hidden;  //browser tab is changed
      //   localStorage.setItem("isTabActive", isActive); // Store active status in localStorage
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    setShowCallLog(backgroundstate.setshowcalllogpage);
  }, [backgroundstate.setshowcalllogpage]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchliveagent();
      setIsOnline(navigator.onLine);
      if (navigator.onLine == false) {
        toast.error("Network Disconnected");
      }
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);



  useEffect(() => {
    var interval = null;
   
    const baseURL = window.location.hostname;
    // const baseURL = "crm-dev.doocti.com/";
    if (baseURL.includes('doocti.com')) {
      setFavicon(dooctilogo)

    } else if (baseURL.includes('gtawk.com')) {
      setFavicon(gtawklogo)
    } else if (baseURL.includes('skyfalltech.in')) {
      setFavicon(skyfalllogo)
    } else if (baseURL.includes('localhost')) {
      // setLogo(dooctilogo)
      setFavicon(dooctilogo)
    } else {
      setFavicon(dooctilogo)
    }

  }, []);
// popupscreen
useEffect(() => {
  const handleBeforeUnload = () => {
    localStorage.setItem("showPopup", "true");
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, []);





  // useEffect(() => {
  //     const handleRefresh = (event) => {
  //         const message = "Agent On the call you want to leave?";

  //         event.returnValue = message; // Required for Chrome to show the alert
  //         if (localStorage.getItem('liveagentdata') == "RINGING" || localStorage.getItem('liveagentdata') == "RINGING" == "CONNECT" ) {
  //             localStorage.setItem('livecall', false)
  //             response.terminate(sipOptions)
  //         }
  //         return message; // Required for some other browsers
  //     };

  //     window.addEventListener('beforeunload', handleRefresh);

  //     return () => {
  //         window.removeEventListener('beforeunload', handleRefresh);
  //     };
  // }, []);

  useEffect(() => {
    if (showCallLog) {
      setIconType(faPhone);
    }
  }, [showCallLog]);
  // let livecall_status = JSON.parse(localStorage.getItem('livecall'))

  // useEffect(() => {
  //     if (livecall_status) {
  //          dispatch(rtcended(true))
  //         dispatch(setshowcalllogpage(false))
  //     }
  // }, [livecall_status])

  const fetchliveagent = () => {
    const liveagentpayload = {
      user: user_name1,
    };
    const token = localStorage.getItem("token")
    if (forceLoutAction(token)) {
      forcelogout();
      return;
    }
    dispatch(AgentFetch(liveagentpayload))
      .then((liveagentres) => {
        if (liveagentres.data.data.length > 0) {
          setLiveagentdata(liveagentres.data.data[0].status);
          localStorage.setItem(
            "liveagentdata",
            liveagentres.data.data[0].status
          );
          dispatch(setagentstatus(liveagentres.data.data[0]));
          if (liveagentres.data.data[0].status == "READY") {
            // localStorage.setItem('livecall', false)
            dispatch(setagentstatus(false));
            dispatch(setagentreadystatus(true));
            setAwayOptionsOpen(false);
          } else if (liveagentres.data.data[0].status == "DISPO") {
            localStorage.setItem("livecall", false);
            setAwayOptionsOpen(true);
            setPause(false);
          }
          else if (callDataRef.current !== '' && callDataRef.current === 'Drop') {
            callDataRef.current = ''; 
          }
          else {
            const liveCall = JSON.parse(localStorage.getItem("livecall"));
            if (liveCall === false) {
              if (config_api.projects[0].userPermission.auto_dispo === true) {
                handleSubmit();
                dispatch(setshowcalllogpage(true));
                localStorage.removeItem("livecall");
              }
            }
            setUserStatus("Agent is unavailable")
            setAwayOptionsOpen(true);
            dispatch(setagentreadystatus(false));
          }
        } else {
          // dispatch(setagentreadystatus(false));
          forcelogout();
        }
      })
      .catch((err) => {
        return err;
      });
  };
 


  const action = async (type, value) => {
    
    if (type === "auto") {
      SetAutodialflag(value);
    } else if (type === "dispo") {

      if (Autodialflag && value == "auto") {

        await dispatch(Autolead("pop"));
        handlechangebarmenu(undefined, "1");
        handlechangebarmenu(undefined, "2");
        // handlechangebarmenu(undefined, "3")
        setShowDialpad(false);
      }
      setis_incoming(false);
    }
  };

  let webrtc_status = backgroundstate.setwebrtcstatus;

  useEffect(() => {
    if (webrtc_status && agentavailable_state && isTabActive) {
      webrtc();
    }
  }, [webrtc_status, isTabActive]);

  useEffect(() => {
    try {
      if (!isTabActive && !sip_status) {
        phone.unregister();
      }
    } catch (error) {
      return;
    }
  });

  const handleDial = (number) => {

    try {
      response.sendDTMF(number);
    } catch (error) {
      console.log(error)
    }
    // response.sendDTMF(number);
  };

  const unregisterWebRTC = () => {
    if (phone) {
      // phone.unregister(); // Unregister from the SIP server
      localStorage.setItem("resume", JSON.stringify(false));
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);

    if (response) {
      if (isMuted) {
        response.unmute();
        setCallStatus("oncall");
      } else {
        response.mute();
        setCallStatus("mute");
      }
    }
  };

  const forcelogout = () => {
  localStorage.clear();  
  navigate("/", { replace: true });
  };

  const toggleHold = () => {
    setIsOnHold(!isOnHold);

    if (response) {
      if (isOnHold) {
        response.unhold();
        setCallStatus("oncall");
      } else {
        response.hold();
        setCallStatus("hold");
      }
    }
  };

  const crmaddlead = () => { };
  const crmviewlead = () => { };
  const handleCallNotesChange = (event) => {
    setCallNotes(event.target.value);
  };
  const handleDispositionStatusChange = (event) => {
    const selectedStatus = event.target.value;
    setDispositionStatus(selectedStatus);
    setIsDispositionSelected(!!selectedStatus);
  };
  const handleSubmit = () => {
    try {
      const local_customer_info = JSON.parse(localStorage.getItem("customer_info"));
      const payload = {
        station: config_api.projects[0].userInfo[0].user_phone_number,
        phone_number: local_customer_info.customer_number,
        //"tenant_id": tenantid,
        entity_type: local_customer_info.module,
        user_id: config_api.projects[0].userInfo[0].user_id,
        customer_id: local_customer_info.customer_id,
        agent: { identity: "user", value: agent_name },
        customer_name:
          local_customer_info.customer_name !== undefined
            ? local_customer_info.customer_name
            : "Unkonwn Name",
        call_type: local_customer_info.call_type,
        lead_id:local_customer_info.customer_id,

      };

      dispatch(Hangup(payload))
        .then((disporesponse) => {
          if (disporesponse.status === 200) {
            let customer_info = {
              response_status: "",
              customer_name: "",
              customer_number: "",
              module: "",
              customer_id: "",
              customer_leadstatus: "",
              customer_leadowner: "",
              call_type: "",
              call_outcome: "",
              lead_id:"",
              StatusFlag:false
            };
            dispatch(setcutomerinfo(customer_info));

            localStorage.removeItem("customer_info");
            localStorage.setItem("livecall", false);
            localStorage.removeItem("callerinfo");
            localStorage.removeItem("livecall");
            if (customer_info.type == "C2C") {
              dispatch(setshowcalllogpage(true));
            } else {
              dispatch(setshowcalllogpage(false));
            }
            dispatch(setshowcalllogpage(true));
            dispatch(rtcended(false));
            dispatch(rtcprocess(true));
            //action("dispo")
          }
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log("error", error);

      return error;
    }
  };

  const getconfigdata = localStorage.getItem("config");
  const getconfig = JSON.parse(getconfigdata);
  let webrtcdomain = getconfig?.projects[0]?.config[0]?.webrtc_domain;
  let webrtc_ip = getconfig?.projects[0]?.config[0]?.webrtc_ip;
  let webrtc_station = getconfig?.projects[0]?.userInfo[0]?.user_phone_number;
  let user_id = getconfig?.projects[0]?.userInfo[0]?.user_id;

  const sendEvent = (calltype, event, phone_number) => {
    const payload = {
      calltype,
      type: event,
      phone_number,
    };
    window.parent.postMessage(payload, "*");
  };

  const webrtc = async () => {
    localStorage.setItem("resume", JSON.stringify(true));
    let webrtcSocket = new JsSIP.WebSocketInterface(`wss://${webrtcdomain}/ws`);
    var configuration = {
      sockets: [webrtcSocket],
      display_name: webrtc_station,
      authorization_user: webrtc_station,
      uri: `sip:${webrtc_station}@${webrtc_ip}`,
      password: webrtc_station,
      realm: webrtc_ip,
      DtlsSrtpKeyAgreement: false,
      contact_uri: `sip:${webrtc_station}@${webrtc_ip}`,
      connection_recovery_min_interval: 5,
      connection_recovery_max_interval: 20,
      use_preloaded_route: true,
      session_timers: false,
      no_answer_timeout: 60000,
      register_expires: 30000000,
      ws_servers: `wss://${webrtc_ip}/ws`,
      trace_sip: true,
    };
    var coolPhone = new JsSIP.UA(configuration);

    coolPhone.start();
    setPhone(coolPhone);

    coolPhone.register();

    coolPhone.on("registered", function (e) {
      console.log(e, "registered", "============>");
      localStorage.setItem("sipstatus", true);
    });

    coolPhone.on("unregistered", function (e) {
      console.log(e, "unregistered", "============>");
    });

    coolPhone.on("registrationFailed", function (e) {
      console.log(e, "registrationFailed", "============>");
    });

    coolPhone.on("connected", function (e) {
      console.log(e, "connected", "============>");

      setBadge("Online");
    });

    coolPhone.on("disconnected", function (e) {
      // toast.error('Sip Disconnected');
      console.log(e, "disconnected", "============>");
    });

    coolPhone.on("newRTCSession", function (e) {
      const session = e.session;
      dispatch(setSession(session));

      const headers = session._request.headers;
      const call_type = headers["Call-Info"]
        ? headers["Call-Info"][0].raw
        : "";
      const cleanCallType = call_type.substring(3);
      const outbount_type = call_type.substring(16);

      let user_context = session._request.from.uri.user;
      let header_context = headers['Caller-Number']?.[0]?.raw
      //  let callee_number = headers['Caller-Number']?.[0]?.raw
      function isValidNumber(number) {
        return typeof number === 'string' && /^\+?\d{8,}$/.test(number);
      }

      let callee_number = null;

      if (isValidNumber(header_context)) {
        callee_number = header_context;
      } else if (isValidNumber(user_context)) {
        callee_number = user_context;
      }

      session.on("ended", function (data) {

        if (config_api.projects[0].userPermission.auto_dispo === true) {
          handleSubmit();
          dispatch(setshowcalllogpage(true));
          localStorage.removeItem("livecall");
        } else if (config_api.projects[0].userPermission.auto_dispo === false) {
          localStorage.setItem("livecall", false);
        }
        setis_incoming(false);

        dispatch(rtcprocess(false));
        dispatch(rtcended(true));

        setCallended(false);
        setWebphone(false);
        setCallStatus("ended");
        setLeadName(leadname);
        setcallername(callername);
        setStarttimer(false);
        // setIncomingdetails(false)
        resetCallDuration();
        console.log("session Ended==============>", data);
        const eventType = cleanCallType === "inbound" ? cleanCallType : outbount_type === "manual" ? "outbound" : "outbound" ;
        const local_customer_info = JSON.parse(localStorage.getItem('customer_info'))
        let cust_number = null
        if(cleanCallType === "inbound"){
          cust_number = callee_number
        }else{
          cust_number = local_customer_info.customer_number
        }
        sendEvent(eventType, "hangup", cust_number);
      });
      session.on("hold", function (data) {
        // The call has been placed on hold
      });

      session.on("failed", function (data) {
        console.log("Failed==========>", data);
        const eventType = cleanCallType === "inbound" ? cleanCallType : outbount_type === "manual" ? "outbound" : "outbound" ;
        const local_customer_info = JSON.parse(localStorage.getItem('customer_info'))
        let cust_number = null
        if(cleanCallType === "inbound"){
          cust_number = callee_number
        }else{
          cust_number = local_customer_info.customer_number
        }
        sendEvent(eventType, "hangup", cust_number);
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
        // dispatch(rtcprocess(false))
        // dispatch(rtcended(true))

        dispatch(setshowcalllogpage(true));
        dispatch(setagentstatus(false));
        dispatch(AutoDialCurrent({}));
        setis_incoming(false);

        setIncomingscreen(false);
        setIncomingdetails(false);
        dispatch(rtcended(false));
        // setInboundcall(false)
        setLeadName(leadname);
        resetCallDuration();
        setWebphone(false);
        let customer_info = {
          response_status: "",
          customer_name: "",
          customer_number: "",
          module: "",
          customer_id: "",
          customer_leadstatus: "",
          customer_leadowner: "",
          call_type: "",
          call_outcome: "",
          StatusFlag:false
        };
        dispatch(setcutomerinfo(customer_info));
        console.log('this is check customer_info')
        localStorage.removeItem("customer_info");
        localStorage.removeItem("livecall");
      });

      session.on("confirmed", function (data) {
        console.log("confirmed==========>", data);


      });
      session.on("accepted", function (data) {
        console.log("accepted==========>", data);


      });

      setResponse(session);
      // dispatch(setSession(session));
      session.on("progress", function (e) {
        console.log(session_state, 'this is checking states')
        console.log("Progress...", session._request.headers);
        const liveCall = JSON.parse(localStorage.getItem("livecall"));
        console.log(liveCall, 'this is check live call 00', typeof livecall_status)
        if (liveCall !== true) {
          try {
            localStorage.setItem("livecall", true);
            dispatch(rtcprocess(true));
            dispatch(setshowcalllogpage(false));
            setShowDialpad(false);
            dispatch(setagentstatus(true)); //based on oncall notshow the icon
            // setWebphone(true)
            dispatch(rtcended(false));
            setStarttimer(true);
            startCallDuration();
            setCallended(true);

            // let callee_number = session._request.from.uri.user;
            // setCallStatus('oncall');
            const headers = session._request.headers;
            // const call_type = headers['Call-Info'][0].raw
            const call_type = headers["Call-Info"]
              ? headers["Call-Info"][0].raw
              : "";
            const ib_queuename = headers["Call-Queue"]
              ? headers["Call-Queue"][0].raw
              : "";
            console.log(call_type, "TESTLOGG", headers["Call-Info"]);
            console.log("Inbound queue name====>", ib_queuename);
            const cleanCallType = call_type.substring(3);
            const outbount_type = call_type.substring(16);
            if (cleanCallType === "inbound") {
              const uid = headers["Call-Uniqueid"][0].raw;
              localStorage.setItem("caller_uid", uid);
              handlechangebarmenu(undefined, "1");
              setInboundcall(true);
              setWebphone(false);
              ringtoneRef.current.loop = true;
              ringtoneRef.current.play().then(() => console.log('this is user audio success')).catch(() => console.log('this is user audio fail'));
              let user_context = session._request.from.uri.user;
              let header_context = headers['Caller-Number']?.[0]?.raw
              //  let callee_number = headers['Caller-Number']?.[0]?.raw
              function isValidNumber(number) {
                return typeof number === 'string' && /^\+?\d{8,}$/.test(number);
              }

              let callee_number = null;

             if (isValidNumber(header_context)) {
  callee_number = header_context;
} else if (isValidNumber(user_context)) {
  callee_number = user_context;
}
              setCallernumber(callee_number);
              const data = {
                type: "Ringing",
                phone_number: callee_number,
              };
              console.log("Incoming call postmessage", data);

              window.parent.postMessage(data, "*");
              let CustomerInfopayload = {
                phone_number: callee_number,
              };

              if (Notification.permission === "granted") {
                new Notification("Incoming call", {
                  body: `Incoming call from ${config_api.projects[0].config[0].masking ? maskPhoneNumber(callee_number, config_api.projects[0].config[0].masking_visible_char) : callee_number}`,
                  icon: favicon, // Optional: You can add an icon for the notification
                });
              }
              dispatch(CustomerInfo(CustomerInfopayload)) //Incoming call
                .then((response) => {
                  if (response.status == 200) {
                    let customer_info = {
                      response_status: response.status,
                      customer_name: response.data.data[0].customerName,
                      customer_number: response.data.data[0].customerNumber,
                      module: response.data.module,
                      customer_id: response.data.data[0].customerID,
                      customer_leadstatus: response.data.data[0].leadStatus,
                      customer_leadowner: response.data.data[0].ownerName,
                      case_number: response.data.data[0].caseNumber ? response.data.data[0].caseNumber : '',
                      account_name: response.data.data[0].accountName ? response.data.data[0].accountName : '',
                      case_id: response.data.data[0].caseId ? response.data.data[0].caseId : '',
                      call_type: "Inbound",
                      call_outcome: "inbound",
                      queue_name: ib_queuename,
                      case_count: response.data.data[0]?.casecount ? response.data.data[0]?.casecount : '',
                      contact_id: response.data.data[0]?.contactId ? response.data.data[0]?.contactId : '',
                      ship_to_account: response.data.data[0]?.shipToAccount ? response.data.data[0]?.shipToAccount : '',
                      StatusFlag: response.data.data[0]?.StatusFlag != undefined ? response.data.data[0]?.StatusFlag : true
                    };
                    dispatch(setcutomerinfo(customer_info));
                    localStorage.setItem(
                      "customer_info",
                      JSON.stringify(customer_info)
                    );
                  } else {
                    let customer_info = {
                      response_status: response.status,
                      case_id: '',

                      customer_name: "UNKNOWN NUMBER",
                      customer_number: callee_number,
                      call_type: "Inbound",
                      call_outcome: "inbound",
                      queue_name: ib_queuename,
                      StatusFlag:true
                    };

                    dispatch(setcutomerinfo(customer_info));
                    localStorage.setItem(
                      "customer_info",
                      JSON.stringify(customer_info)
                    );
                  }
                  // setWaiting(false);
                })
                .catch((err) => {
                  if (err.code === "ECONNABORTED") {
                    let customer_info = {
                      response_status: response.status,
                      customer_name: "UNKNOWN NUMBER",
                      customer_number: callee_number,
                      call_type: "Inbound",
                      call_outcome: "inbound",
                      queue_name: ib_queuename,
                      case_id: '',
                      StatusFlag:true
                    };

                    dispatch(setcutomerinfo(customer_info));
                    localStorage.setItem(
                      "customer_info",
                      JSON.stringify(customer_info)
                    );
                  } else {
                    return err;
                  }
                });

              setIncomingscreen(true);
            }
            if (outbount_type === "manual") {
              setInboundcall(false);
              setWebphone(true);
              setTimeout(function () {
                session.answer(sipOptions);
              }, 500);
              setWebphone(true);
            } else {
              setis_incoming(true);
              setIncomingscreen(true);

              console.log("Auto Answer Failed");
            }

            //  localStorage.setItem('setCallended',false)
          } catch (error) {
            console.log(error, "Uncaught")
          }
        }
      });

      // Determine if it's an incoming or outgoing call
      if (session.direction === "outgoing") {
        // Handle outgoing call

        console.log("Outgoing call initiated to:");
      } else if (session.direction === "incoming") {
        console.log("session.direction======================>", session);
        //let callee_number = session._request.from.uri.user;
        setCallStatus("oncall");
        // setIncomingscreen(true)
        //const headers = session._request.headers;
        //const call_type = headers['Call-Info'][0].raw
        //const ib_queuename = headers['Call-Queue']?headers['Call-Queue'][0].raw :'';
        //console.log("Inbound queue name====>",ib_queuename);
        //const cleanCallType = call_type.substring(3);
        //const outbount_type = call_type.substring(16);
        // if (cleanCallType === 'inbound') {
        //     handlechangebarmenu(undefined, "1")
        //     setInboundcall(true)
        //     setWebphone(false)
        //     ringtoneRef.current.loop = true;
        //     ringtoneRef.current.play();
        //     setCallernumber(callee_number)
        //     const data = {
        //         type: "Ringing"
        //     }
        //     window.parent.postMessage(data, '*');
        //     let CustomerInfopayload = {
        //         phone_number: callee_number
        //     }

        //     if (Notification.permission === "granted") {
        //         new Notification("Incoming call", {
        //             body: `Incoming call from ${callee_number}`,
        //             icon: favicon // Optional: You can add an icon for the notification
        //         });
        //     }
        //     dispatch(CustomerInfo(CustomerInfopayload)).then((response) => {
        //         if (response.status == 200) {
        //             let customer_info = {
        //                 response_status: response.status,
        //                 customer_name: response.data.data[0].customerName,
        //                 customer_number: callee_number,
        //                 module: response.data.module,
        //                 customer_id: response.data.data[0].customerID,
        //                 customer_leadstatus: response.data.data[0].status,
        //                 customer_leadowner: response.data.data[0].ownerName,
        //                 call_type: "Inbound",
        //                 queue_name:ib_queuename
        //             }
        //             dispatch(setcutomerinfo(customer_info))
        //             localStorage.setItem('customer_info', JSON.stringify(customer_info))
        //             setIncomingscreen(true)

        //         } else {
        //             let customer_info = {
        //                 response_status: response.status,
        //                 customer_name: "UNKNOWN NUMBER",
        //                 customer_number: callee_number,
        //                 call_type: "Inbound",
        //                 queue_name:ib_queuename
        //             }

        //             dispatch(setcutomerinfo(customer_info))
        //             localStorage.setItem('customer_info', JSON.stringify(customer_info))

        //         }

        //     }).catch((err) => {
        //         return err
        //     })

        // }
        // if (outbount_type === 'manual') {
        //     setInboundcall(false)
        //     setWebphone(true)
        //     setTimeout(function () {
        //         session.answer(sipOptions)
        //     }, 500)

        // }
        // else {
        //     setis_incoming(true)
        //     setIncomingscreen(true)

        //     console.log("Auto Answer Failed");

        // }

        session.on("peerconnection", function (data) {
          data.peerconnection.addEventListener("addstream", function (e) {
            let remoteAudio = document.createElement("audio");
            remoteAudio.srcObject = e.stream;
            remoteAudio.play();

            // sound(false)
          });
        });
      }
    });
  };

  const startCallDuration = () => {
    if (!callStartTime) {
      setCallStartTime(new Date());
    }
  };
  const resetCallDuration = () => {
    setCallStartTime(null);
    setCallDuration(0);
  };

  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
    window.addEventListener("message", incomingresponse);
  }, []);

  const incomingresponse = async (event) => {
    let inboundlead_name = event.data.lead_name;
    if (inboundlead_name) {
      // setcallername(inboundlead_name)
      setLeadName(inboundlead_name);
      setcallername(inboundlead_name);
    }
  };
  // useEffect(() => {
  //     fetchDispo();
  // }, [])

  useEffect(() => {
    const crmname = localStorage.getItem("config");
    const crmowner_name = JSON.parse(crmname)?.projects[0]?.userInfo[0]?.user_name;
    if (callername == "" || callername == null || callername == undefined) {
      setcallername("Unkown Name");
    }
    setcrmownername(crmowner_name);
    if (callStartTime) {
      const timer = setInterval(() => {
        const currentTime = new Date();
        const durationInSeconds = Math.floor(
          (currentTime - callStartTime) / 1000
        );
        setCallDuration(durationInSeconds);
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [callStartTime]);

  useEffect(() => {
    const debouncedHandleMessage = _.debounce(handleMessage, 1000); // Adjust the delay as needed

    window.addEventListener("message", debouncedHandleMessage);

    return () => {
      window.removeEventListener("message", debouncedHandleMessage);
    };
  }, []); // Empty dependency array means this runs once on mount and cleanup on unmount

  const CrmConvertDatas = (data) => {

    let parsedData = JSON.parse(data);

    let customer_data = {
      customer_name: parsedData.recordTitle,
      customer_number: parsedData.value,
      customer_id: parsedData.entityId,
      module: parsedData.entityLogicalName,

      call_type: "Outbound",
      call_outcome: "manual",
      type: "C2C",
      StatusFlag:true
    };
    return customer_data;
  };

  const handleMessage = async (event) => {
    try {
      if (event.data && event.data.source === 'react-devtools-bridge') {
        return;
      }
      console.log("C2C Event Data:", event.data);
      if (event?.data?.event == "Logout") {
       logout()
       return;
        
      }
      let live_agent_status = localStorage.getItem("liveagentdata");
      let livecall = JSON.parse(localStorage.getItem("livecall"));
      if ((live_agent_status === "DISPO" || live_agent_status === "RINGING" || live_agent_status === "CONNECT") || livecall) {
        let { type } = event.data;
        if (type === undefined) {
          toast.error("Agent is on another call");
        }
        return;
      }
      handlechangebarmenu(undefined, "1");

      let entity_number;
      let lead_id1;
      let customer_info = {};
      const api_domain = JSON.parse(localStorage.getItem("token"));
      const apiToken = api_domain.access_token;
      const stationnumber = webrtc_station;
      const module = "Leads";
      // entity_number = event.data.data.number ||event.data.data.entity_number;
      let entityLogincalName;
      if (event.data.messageData) {
        entityLogincalName = JSON.parse(event.data.messageData)?.entityLogicalName
      }
      if (event.data.type == "Manual") {
        //freshdesk //Manual
        
        entity_number = event.data.data.number;
        lead_id1 = event.data.data.id;

        let CustomerInfopayload = {
          phone_number: entity_number,
        };
        setDefaultCustomerInfo(entity_number, stationnumber, lead_id1)
        dispatch(CustomerInfo(CustomerInfopayload))
          .then((response) => {
            let customer_info;
            if (response.status == 200) {
              customer_info = {
                response_status: response.status,
                customer_name: response.data.data[0].customerName,
                customer_number: entity_number,
                module: response.data.module,
                customer_id: response.data.data[0].customerID,
                case_id: response.data.data[0]?.caseId ? response.data.data[0].caseId : '',
                case_count: response.data.data[0]?.casecount ? response.data.data[0]?.casecount : '',
                contact_id: response.data.data[0]?.contactId ? response.data.data[0]?.contactId : '',
                ship_to_account: response.data.data[0]?.shipToAccount ? response.data.data[0]?.shipToAccount : '',
                // customer_leadstatus: response.data.data[0].status,
                // customer_leadowner: response.data.data[0].ownerName,
                call_type: "Outbound",
                call_outcome: "manual",
                StatusFlag: response.data.data[0]?.StatusFlag != undefined ? response.data.data[0]?.StatusFlag : true
              };
              dispatch(setcutomerinfo(customer_info));
              localStorage.setItem(
                "customer_info",
                JSON.stringify(customer_info)
              );
              // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
            } else {
              console.log("Reponse 204============>",config_api.projects[0].userPermission.auto_lead_create);
              
              if (config_api.projects[0].userPermission.auto_lead_create) {
                const createpayload = {
                  module: "Leads",
                  payload: {
                    owner_name: user_id,
                    phone_number: entity_number,
                  },
                };

                dispatch(Createcrm(createpayload))
                  .then((createresponse) => {
                    if (createresponse.status === 201) {
                      let customer_info = {
                        response_status: createresponse.status,
                        customer_name: createresponse.data.data.customerName,
                        customer_number: entity_number,
                        module: createresponse.data.module,
                        customer_id: createresponse.data.data.customerID,
                        customer_leadstatus: createresponse.data.data.callStatus,
                        customer_leadowner: createresponse.data.data.ownerName,
                        call_type: "Outbound",
                        call_outcome: "manual",
                        StatusFlag: createresponse.data.data[0]?.StatusFlag != undefined? createresponse.data.data[0]?.StatusFlag : true
                      };
                      dispatch(setcutomerinfo(customer_info));
                      localStorage.setItem(
                        "customer_info",
                        JSON.stringify(customer_info)
                      );
                      toast.success('New Data Created');
                      // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
                    }
                  })
                  .catch((err) => {
                    toast.error("Lead not created");
                    console.log(err);
                    return err;
                  });
              } else {
                let customer_info = {
                  customer_name: "UNKNOWN NUMBER",
                  customer_number: entity_number,
                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag:true
                };

                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
                // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
              }
            }
          })
          .catch((err) => {
            if (err.code === "ECONNABORTED") {
              setDefaultCustomerInfo(entity_number, stationnumber, lead_id1)
            } else {
              return err;
            }
          });
        // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
      } else if (event.data.messageType === "onclicktoact" && entityLogincalName !== "lead") {//Dynamic crm
        let customer_info = CrmConvertDatas(event.data.messageData);
        entity_number = customer_info.customer_number;
        dispatch(setcutomerinfo(customer_info));
        localStorage.setItem("customer_info", JSON.stringify(customer_info));
        // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
      } else {  //zoho,salesforce
        let parsedData = {};
        if (event.data.messageType === "onclicktoact") {
          parsedData = JSON.parse(event.data.messageData);
          entity_number = parsedData.value;
        }
        if (parsedData.value && event.data.messageType === "onclicktoact") {
          let CustomerInfopayload = {
            leadId: parsedData.entityId,
            field: "leadId"
          }
          dispatch(CustomerInfo(CustomerInfopayload))
            .then((response) => {
              if (response.status == 200) {
                let customer_info = {
                  customer_name: response.data.data[0].customerName,
                  customer_number: entity_number,
                  module: parsedData.entityLogicalName,
                  customer_id: parsedData.entityId,
                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag: response.data.data[0]?.StatusFlag != undefined? response.data.data[0]?.StatusFlag : true
                };
                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
              } else {
                let customer_info = {
                  customer_name: "UNKNOWN NUMBER",
                  customer_number: entity_number,
                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag:true
                };

                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
              }
            })
            .catch((err) => {
              console.log(err, 'this is check 3')
              if (err.code === "ECONNABORTED") {
                let customer_info = {
                  customer_name: "UNKNOWN NUMBER",
                  customer_number: entity_number,
                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag:true
                };

                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
              } else {
                return err;
              }
            });
          console.log('this is check 1')
        } else if (event.data.data.customer_number) {
          entity_number = event.data.data.customer_number;
          lead_id1 = event.data.data.customer_id;

          let CustomerInfopayload = {
            phone_number: entity_number,
          };
          // if (config_api.projects[0].userPermission.customModule) {
          if(event?.data?.data?.module != undefined){
            CustomerInfopayload.module = event.data.data.module
          }
          // }
          setDefaultCustomerInfo(entity_number, stationnumber, lead_id1)
          dispatch(CustomerInfo(CustomerInfopayload))
            .then((response) => {
              if (response.status == 200) {
                let customer_info = {
                  customer_name: response.data.data[0].customerName,
                  case_id: response.data.data[0].caseId ? response.data.data[0].caseId : '',
                  case_count: response.data.data[0]?.casecount ? response.data.data[0]?.casecount : '',
                  contact_id: response.data.data[0]?.contactId ? response.data.data[0]?.contactId : '',
                  ship_to_account: response.data.data[0]?.shipToAccount ? response.data.data[0]?.shipToAccount : '',

                  customer_number: entity_number,
                  module: event.data.data.module,
                  customer_id: response.data.data[0].customerID ? response.data.data[0].customerID : '',
                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag: response.data.data[0]?.StatusFlag != undefined ? response.data.data[0]?.StatusFlag : true
                };
              

                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
                // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
              } else {
                let customer_info = {
                  customer_name: "UNKNOWN NUMBER",
                  customer_number: entity_number,
                  case_id: '',

                  call_type: "Outbound",
                  call_outcome: "manual",
                  type: "C2C",
                  StatusFlag:true
                };

                dispatch(setcutomerinfo(customer_info));
                localStorage.setItem(
                  "customer_info",
                  JSON.stringify(customer_info)
                );
                // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
              }
            })
            .catch((err) => {
              if (err.code === "ECONNABORTED") {
                setDefaultCustomerInfo(entity_number, stationnumber, lead_id1)
              } else {
                return err;
              }
            });
          // makeACall(entity_number,stationnumber,lead_id1,customer_info.customer_name)
        } else {//custom crm
         
          
          lead_id1 = event.data.data.entity_id;
          entity_number = event.data.data.entity_number;
          let cli_number = event.data.data?.cli_number
          let crmUniqueid = event.data.data?.crm_unique_id
          let customer_info = {
            customer_name: event.data.data.entity_name,
            customer_number: entity_number,
            module: event.data.data.entity_type || "",
            customer_id: event.data.data.entity_id,
            call_type: "Outbound",
            call_outcome: "manual",
            type: "C2C",
            StatusFlag:true
          };
          dispatch(setcutomerinfo(customer_info));
          localStorage.setItem("customer_info", JSON.stringify(customer_info));
          //  setDefaultCustomerInfo(entity_number, stationnumber, lead_id1)
          
           setDefaultCustomerInfo(entity_number,stationnumber,lead_id1,customer_info.customer_name,cli_number,crmUniqueid);
        }
      }


    } catch (error) {
      console.error("Error making call:", error);
    }
  };

  const makeACall = (entity_number, stationnumber, lead_id1, customer_name,cli_number,crmUniqueid) => {
    if (entity_number !== null && entity_number !== undefined && localStorage.getItem("liveagentdata") == "READY") {
      const payload = {
        station: stationnumber,
        phone_number: entity_number,
        caller_name: customer_name,
        cli_number:cli_number,
        agent: {
          identity: "user",
          value: user_name1,
        },
        custdata: {
          lead_id: lead_id1,
          crm_unique_id:crmUniqueid,
          module: module,
        },
      };

      dispatch(MakeManualcall(payload))
        .then((callresponse) => {
          if (callresponse.status === 200) {
            localStorage.setItem(
              "callstatus",
              JSON.stringify(response.status)
            );
            localStorage.setItem("caller_uid", callresponse.data.uid)

            //SetAutodialflag(false)
            // setWebphone(true)
          } else if (callresponse.status === 204) {
            setPause(false);
          } else {
            setPause(true);
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            localStorage.removeItem("login");
            localStorage.removeItem("hanguppayload");
            localStorage.removeItem("resume");
            localStorage.removeItem("agentstatus");
            localStorage.removeItem("config");
            localStorage.removeItem("username");
            localStorage.removeItem("apinfo");
            localStorage.removeItem("token");
            localStorage.removeItem("callstatus");
            localStorage.removeItem("queuelogin");
            //localStorage.removeItem('crmuserinfo');
            localStorage.removeItem("entititytype");
            localStorage.removeItem("station");
            localStorage.removeItem("livecall");
            localStorage.removeItem("callstatus");
            window.location.href = `/`;
          } else {
            setPause(true);
          }
          localStorage.setItem(
            "callstatus",
            JSON.stringify(err.response.status)
          );
        });
    } else if (localStorage.getItem("liveagentdata") == "PAUSE" || localStorage.getItem("liveagentdata") == "CONNECT" || localStorage.getItem("liveagentdata") == "RINGING") {
      setPause(true);
    }
  }

  const answercall = async () => {
    response.answer(sipOptions);
    setIncomingdetails(true);
    setIncomingscreen(false);
    setWebphone(true);

    if (
      config_api.projects[0].userPermission.auto_lead_create &&
      customer_info_state.customer_name == "UNKNOWN NUMBER"
    ) {
      const createpayload = {
        module: "Leads",
        payload: {
          owner_name: user_id,
          phone_number: callernumber,
        },
      };

      dispatch(Createcrm(createpayload))
        .then((createresponse) => {
          if (createresponse.status === 201) {
            let customer_info = {
              response_status: createresponse.status,
              customer_name: createresponse.data.data.customerName,
              customer_number: callernumber,
              module: createresponse.data.module,
              customer_id: createresponse.data.data.customerID,
              customer_leadstatus: createresponse.data.data.callStatus,
              customer_leadowner: createresponse.data.data.ownerName,
              call_type: "Inbound",
              call_outcome: "manual",
              StatusFlag: createresponse.data.data[0]?.StatusFlag != undefined? createresponse.data.data[0]?.StatusFlag : true
            };
            dispatch(setcutomerinfo(customer_info));
            localStorage.setItem(
              "customer_info",
              JSON.stringify(customer_info)
            );
            toast.success('New Data Created');
          }
        })
        .catch((err) => {
          return err;
        });
    }

    ringtoneRef.current.pause();
    ringtoneRef.current.currentTime = 0;
  };

  const declinecall = async () => {
    response.terminate(sipOptions);
    // response.terminate({
    //     status_code: 603,
    //     reason_phrase: 'Decline',
    // });
    ringtoneRef.current.pause();
    ringtoneRef.current.currentTime = 0;
    let customer_info = {
      response_status: "",
      customer_name: "",
      customer_number: "",
      module: "",
      customer_id: "",
      customer_leadstatus: "",
      customer_leadowner: "",
      call_type: "",
      call_outcome: "",
      StatusFlag:false
    };
    dispatch(setcutomerinfo(customer_info));
   
    localStorage.removeItem("customer_info");
  };

  function toggleUserOptions() {
    const userOptions = document.getElementById("userOptions");
    userOptions.style.display =
      userOptions.style.display === "block" ? "none" : "block";
  }
  function logout() {
    try {
      const logutpayload = {
        user: user_name1,
        station: station,
      };
      console.log("logutpayload=============>",logutpayload);
      
      // dispatch(Logout(logutpayload))

      dispatch(Logout(logutpayload))
        .then((response) => {
          if (response.status === 200) {
            phone.unregister();

            forcelogout();
            // .then(() => {
            //   // Refresh the window after navigating
            //   window.location.reload();
            // })
            // .catch((err) => {
            //   return err;
            // });
          }
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      return error;
    }
  }

  const handlechangebarmenu = (event, newValue) => {
    viewWaitingCalls(false)
    if (newValue == "2") {
      dispatch(setshowcalllogpage(false));
      dispatch(rtcprocess(true));
    } else if (newValue == "3") {
      dispatch(setshowcalllogpage(false));

      setShowDialpad(true);
    } else {
      dispatch(setshowcalllogpage(true));
      // dispatch(rtcprocess(false))
      localStorage.setItem("Showautodialpageui", false);
    }
    setbarmenuvalue(newValue);
  };

  function HandleSetBadge(badge) {
    const userOptions = document.getElementById("userOptions");
    userOptions.style.display = "none";
    if (badge == "Online") {
      setBadge("Online");
      setPause(false);
      const agentname = localStorage.getItem("username");
      const payload = {
        user: agentname,
      };
      dispatch(Resume(payload))
        .then((resumeresponse) => {
          if (resumeresponse.status == 200) {
            localStorage.setItem("agentstatus", true);
            setAwayOptionsOpen(false);
            webrtc();
          }
        })
        .catch((err) => {
          // if (err.response.status == 400) {
          //     // forcelogout()
          // }
          return err;
        });
    } else if (badge == "Away") {
      setBadge("Away");
      setAwayOptionsOpen(true);
    } else {
      setAwayOptionsOpen(false);
      const agentname = localStorage.getItem("username");
      const payload = {
        user: agentname,
        reason: badge,
      };
      dispatch(Pause(payload))
        .then((pauseresponse) => {
          if (pauseresponse.status == 200) {
            localStorage.setItem("agentstatus", false);
            setAwayOptionsOpen(true);
            unregisterWebRTC();
          }
        })
        .catch((err) => {
          // if (err.response.status == 400) {
          //     forcelogout()
          // }
          return err;
        });
    }
  }

  function socketIo() {
    let apiInfo = JSON.parse(localStorage.getItem('apinfo'));
    let url = `${apiInfo.socket_url}`;
    let socket = io(url, {
      reconnection: true,
      query: {
        token: apiInfo.token,
        type: 'doocti',
      },
      forceNew: true,
      allowEIO3: true
    })

    dispatch(socketconnection(socket))

    socket.on('connect', (error) => {
      let userData = {
        socket_id: socket.id,
        station: config_api.projects[0].userInfo[0].user_phone_number,
        type: "doocti",
        tenant_id: config_api.tenant_code,
        agent: config_api.projects[0].userInfo[0].user_email,
        campaign: selectedCampaign,
      }
   
      socket.emit("client-info", userData);
      dispatch(networkstatus("online"))
      dispatch(websocketstatus({ WsSocketStatus: true }))
    })

    socket.on('queue-waiting-response', function (data) {
      let datas = data.rows.reverse();
      setWaitingCalls(datas);
    })

    socket.on("message", (data) => {
     
      if (data.evt === "DISPO") {
        if (config_api.projects[0].userPermission.auto_dispo === true) {
          handleSubmit();
          
          dispatch(setshowcalllogpage(true));
          localStorage.removeItem("livecall");
        }
      }
      else if (data.evt === "Drop") {
        callDataRef.current = data.evt;
        dispatch(setshowcalllogpage(true));
        localStorage.removeItem("livecall");
      }
    })

    socket.on("call-grab-response", (data) => {
    })

  }



  const viewWaitingCalls = (open = true) => {
    setWaiting(open);
    return;
  }

  const viewIncomingCalls = (data) => {
    try {
     

      localStorage.setItem("livecall", true);
      dispatch(rtcprocess(true));
      dispatch(setshowcalllogpage(false));
      setShowDialpad(false);
      dispatch(setagentstatus(true)); //based on oncall notshow the icon
      // setWebphone(true)
      dispatch(rtcended(false));
      setStarttimer(true);
      startCallDuration();
      setCallended(true);

      handlechangebarmenu(undefined, "1");
      setInboundcall(true);
      setWebphone(false);
      ringtoneRef.current.loop = true;
      ringtoneRef.current.play();
      // let callee_number = session._request.from.uri.user;
      // setCallernumber(callee_number);
      const CustomerInfopayload = {
        type: "Ringing",
        phone_number: data.phonenumber,
      };
      console.log("Incoming call postmessage", CustomerInfopayload);
      window.parent.postMessage(CustomerInfopayload, "*");

      // let CustomerInfopayload = {
      //   phone_number: data.phonenumber,
      // };

      dispatch(CustomerInfo(CustomerInfopayload)).then((response) => {
        if (response.status == 200) {
          let customer_info = {
            response_status: response.status,
            customer_name: response.data.data[0].customerName,
            customer_number: CustomerInfopayload.phone_number,
            module: response.data.module,
            customer_id: response.data.data[0].customerID,
            customer_leadstatus: response.data.data[0].leadStatus,
            customer_leadowner: response.data.data[0].ownerName,
            call_type: "Inbound",
            call_outcome: "inbound",
            StatusFlag: response.data.data[0]?.StatusFlag != undefined ? response.data.data[0]?.StatusFlag : true
            // queue_name: ib_queuename,
          };
          dispatch(setcutomerinfo(customer_info));
          localStorage.setItem(
            "customer_info",
            JSON.stringify(customer_info)
          );
        } else {
          let customer_info = {
            response_status: response.status,
            customer_name: "UNKNOWN NUMBER",
            customer_number: CustomerInfopayload.phone_number,
            call_type: "Inbound",
            call_outcome: "inbound",
            StatusFlag:true
            // queue_name: ib_queuename,
          };

          dispatch(setcutomerinfo(customer_info));
          localStorage.setItem(
            "customer_info",
            JSON.stringify(customer_info)
          );
        }
      }).catch((err) => {
        if (err.code === "ECONNABORTED") {
          let customer_info = {
            response_status: response.status,
            customer_name: "UNKNOWN NUMBER",
            customer_number: CustomerInfopayload.phone_number,
            call_type: "Inbound",
            call_outcome: "inbound",
            StatusFlag:true
            // queue_name: ib_queuename,
          };

          dispatch(setcutomerinfo(customer_info));
          localStorage.setItem(
            "customer_info",
            JSON.stringify(customer_info)
          );
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const setDefaultCustomerInfo = (entity_number, stationnumber, lead_id1,lead_name,cli_number,crmUniqueid) => {
    
    try {
      let customer_info = {
        customer_name: lead_name || "UNKNOWN NUMBER",
        customer_number: entity_number,
        call_type: "Outbound",
        call_outcome: "manual",
        type: "C2C",
        StatusFlag:true
      };

      dispatch(setcutomerinfo(customer_info));
      localStorage.setItem(
        "customer_info",
        JSON.stringify(customer_info)
      );
      makeACall(entity_number, stationnumber, lead_id1, customer_info.customer_name,cli_number,crmUniqueid)
    } catch (error) {
      console.log(error)
    }
  }



const configId = localStorage.getItem("config");





  return (
    <div>
      {/* <div>{configId}</div> */}
      {webphone ? (
        <Webphone is_incoming={is_incoming} waitingCalls={waitingCalls} viewWaitingCalls={viewWaitingCalls} handleDial={handleDial} />
      ) : barmenuvalue == "2" && backgroundstate.rtcprocess && !webphone ? (
        <div>
          <Comtemplete
            viewWaitingCalls={viewWaitingCalls}
            waitingCalls={waitingCalls}
            toggleUserOptions={toggleUserOptions}
            badge={badge}
            logout={logout}
            handleSetBadge={HandleSetBadge}
            awayOptionsOpen={awayOptionsOpen}
          >
            <Autodial action={action} Autodialflag={Autodialflag} />
          </Comtemplete>
        </div>) : waiting ? (
          <Comtemplete
            viewWaitingCalls={viewWaitingCalls}
            waitingCalls={waitingCalls}
            toggleUserOptions={toggleUserOptions}
            badge={badge}
            logout={logout}
            handleSetBadge={HandleSetBadge}
            awayOptionsOpen={awayOptionsOpen}
          >
            <div id="top" class="page-wrap">
              <WaitingCalls waitingCalls={waitingCalls} />
            </div>
          </Comtemplete>
        ) :
        pause ? (
          <div>
            <Comtemplete
              viewWaitingCalls={viewWaitingCalls}
              toggleUserOptions={toggleUserOptions}
              badge={badge}
              logout={logout}
              handleSetBadge={HandleSetBadge}
              awayOptionsOpen={awayOptionsOpen}
            >
              <div id="top" class="page-wrap">
                <div className="agent-pause">
                  <img class="pause-illust" src={pausewave}></img>
                  <div className="pause-notes">{userStatus}</div>
                </div>
              </div>
            </Comtemplete>
          </div>
        ) : incomingscreen ? (
          <div>
            <Incomingcallscreen
              onAnswer={answercall}
              onDecline={declinecall}
              leadname={callername}
              leadnumber={callernumber}
              leaddate={ibleaddate}
              leadowner={"Pandi"}
            />
          </div>
        ) : (livecall_status == false && config_api.projects[0].userPermission.auto_dispo === false && callDataRef.current !== 'Drop') ? (
          <div>
            <Disposcreen action={action} waitingCalls={waitingCalls} />
          </div>
        ) : backgroundstate.setshowcalllogpage ? (
          <div>
            <Comtemplete
              viewWaitingCalls={viewWaitingCalls}
              waitingCalls={waitingCalls}
              toggleUserOptions={toggleUserOptions}
              badge={badge}
              logout={logout}
              handleSetBadge={HandleSetBadge}
              awayOptionsOpen={awayOptionsOpen}
            >
              <div id="top" class="page-wrap">
                <CallLog />
              </div>
            </Comtemplete>
          </div>
        ) : showDialpad && barmenuvalue == "3" && !config_api.projects[0].userPermission.manual_dial_switch   ? (
          <div>
            <Comtemplete
              viewWaitingCalls={viewWaitingCalls}
              waitingCalls={waitingCalls}
              toggleUserOptions={toggleUserOptions}
              badge={badge}
              logout={logout}
              handleSetBadge={HandleSetBadge}
              awayOptionsOpen={awayOptionsOpen}
            >
              <Dialpad />
            </Comtemplete>
          </div>
        ) : (
          <div>
            <Comtemplete
              toggleUserOptions={toggleUserOptions}
              badge={badge}
              logout={logout}
              handleSetBadge={HandleSetBadge}
              awayOptionsOpen={awayOptionsOpen}
            >
              <div id="top" class="page-wrap">
                <CallLog />
              </div>
            </Comtemplete>
          </div>
        )}
        {/* popupscreen */}
       
     {popup &&   <PopupScreen closePopup={()=>SetPopup(false)} />}  
      {/* Bottom Navigation */}
      {/* {barmenuvalue == "2" && backgroundstate.rtcprocess && !webphone && (
        <Comtemplete
          viewWaitingCalls={viewWaitingCalls}
          toggleUserOptions={toggleUserOptions}
          badge={badge}
          logout={logout}
          handleSetBadge={HandleSetBadge}
          awayOptionsOpen={awayOptionsOpen}
        >
          <Autodial action={action} Autodialflag={Autodialflag} />
        </Comtemplete>
      )} */}
      {/* {barmenuvalue == "3" && backgroundstate.rtcprocess && !webphone && <Dashboard/>} */}
      {liveagentdata !== "RINGING" &&
        liveagentdata !== "CONNECT" &&
        liveagentdata !== "DISPO" && (
          <div className="bottom_navigation">
            <BottomNavigation
              showLabels
              onChange={handlechangebarmenu}
              value={barmenuvalue}
            >
              <BottomNavigationAction
                label="Home"
                value="1"
                icon={<FontAwesomeIcon icon={faHouse} />}
              />
              {!config_api?.projects[0]?.userPermission?.manual_dial_switch && (
              <BottomNavigationAction
                label="Dialpad"
                value="3"
                icon={<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={barmenuvalue === "3" ? "#2196f3" : "#666666"}><path d="M479.79-48Q450-48 429-69.21t-21-51Q408-150 429.21-171t51-21Q510-192 531-170.79t21 51Q552-90 530.79-69t-51 21Zm-216-720Q234-768 213-789.21t-21-51Q192-870 213.21-891t51-21Q294-912 315-890.79t21 51Q336-810 314.79-789t-51 21Zm0 240Q234-528 213-549.21t-21-51Q192-630 213.21-651t51-21Q294-672 315-650.79t21 51Q336-570 314.79-549t-51 21Zm0 240Q234-288 213-309.21t-21-51Q192-390 213.21-411t51-21Q294-432 315-410.79t21 51Q336-330 314.79-309t-51 21Zm432-480Q666-768 645-789.21t-21-51Q624-870 645.21-891t51-21Q726-912 747-890.79t21 51Q768-810 746.79-789t-51 21Zm-216 480Q450-288 429-309.21t-21-51Q408-390 429.21-411t51-21Q510-432 531-410.79t21 51Q552-330 530.79-309t-51 21Zm216 0Q666-288 645-309.21t-21-51Q624-390 645.21-411t51-21Q726-432 747-410.79t21 51Q768-330 746.79-309t-51 21Zm0-240Q666-528 645-549.21t-21-51Q624-630 645.21-651t51-21Q726-672 747-650.79t21 51Q768-570 746.79-549t-51 21Zm-216 0Q450-528 429-549.21t-21-51Q408-630 429.21-651t51-21Q510-672 531-650.79t21 51Q552-570 530.79-549t-51 21Zm0-240Q450-768 429-789.21t-21-51Q408-870 429.21-891t51-21Q510-912 531-890.79t21 51Q552-810 530.79-789t-51 21Z" /></svg>}
              />
              )}
              {config_api?.projects[0]?.userPermission?.auto_dial && (
                <BottomNavigationAction
                  label="Lead Dial"
                  value="2"
                  icon={<FontAwesomeIcon icon={faUser} />}
                />
              )}

              {/* <BottomNavigationAction label="Dashboard" value="3" icon={<FontAwesomeIcon icon={faHouse} />} />
               */}
            </BottomNavigation>
          </div>
        )}
    </div>
  );
}

export default Homepage;
